<template>
    <div id="section" class="Section">
        <Map/>
        <transition name="Section__nav">
            <div 
                id="nav" 
                class="Section__nav" 
                :class="[{ 'is-active': open }]"
                @click="onClick()" 
                v-if="!artwork_used && !welcome">
                <div class="Section__burger-wrapper" :class="[{ 'is-active': open }]">
                    <span class="Section__burger" />
                </div>  
            </div>
        </transition>
        <Artwork v-if="artwork_used"/>
        <Complements ref="complements" v-if="open"/> 
        <Overlay v-if="welcome"/>
    </div>
</template>

<script> 

import Mixin from '@/mixins/Smooth.js'
import Complements from '@/components/Complements.vue'
import Overlay from '@/components/Overlay.vue'
import Map from '@/components/Map.vue'
import Artwork from '@/components/Artwork.vue'

export default {

    name: 'Section',
    mixins: [Mixin],
    components: { Complements, Overlay, Map, Artwork },
    data: () => ({
        open: false,
        welcome: false,
        width: window.innerWidth,
        height: window.innerHeight,
        scenes: []
    }),
    computed: {
        artwork_used() {
          return this.$store.getters['app/artwork_used']
        }
    },
    mounted() {   
        this.$nextTick(()=>{
            if(!this.$route.params.id)
                this.welcome = true         
        })
    },
    methods: {  
        onClick: async function() {
            if(this.open)
                await this.$refs.complements.leave()
            this.open = !this.open
        },
    }
}
</script>

<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'
@import '~@/commons/stylus/Hamburger-icon'

.Section 
    color black
    display flex
    position fixed
    top 0
    left 0
    width 100vw
    height 100%

    &__nav
        position fixed
        background white
        bottom 48px
        width 60px
        height 60px
        left 50%
        transition opacity .25s, transform .25s
        transition-timing-function cubic-bezier(0.25, 0.1, 0.25, 1)
        cubic-bezier(0.25, 0.1, 0.25, 1)
        transform translate(-50%, 0)
        opacity 1
        cursor pointer
        z-index 100
        &-enter
        &-leave-active
            opacity 0
            transform translate(-50%, -20px)
            pointer-events none
        display flex
        align-items center
        justify-content center
        &.is-active
            background black

    &__burger
        hamburger-generator(30px, 2px, 5px, black, $timing-function: linear)

    &__burger-wrapper
        position absolute
        cursor pointer
        z-index 2
        &.is-active
            .Section__burger
                hamburger-animation()
            .Section__burger:before 
            .Section__burger:after
                background white
       
</style>


